import { render, staticRenderFns } from "./versionHistory.vue?vue&type=template&id=27a0b9c3&scoped=true&"
import script from "./versionHistory.vue?vue&type=script&lang=js&"
export * from "./versionHistory.vue?vue&type=script&lang=js&"
import style0 from "./versionHistory.vue?vue&type=style&index=0&id=27a0b9c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0b9c3",
  null
  
)

export default component.exports